import React from "react";
import { Link } from "react-router-dom";

/**
 * Route-level error boundary — guarantees a malformed post / render error never
 * results in a completely blank white page. Shows a friendly message instead.
 * Reset it by giving it a `key` that changes on navigation (see App routes).
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Surface the real root cause in the console for debugging (not hidden).
    // eslint-disable-next-line no-console
    if (typeof console !== "undefined") console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div className="ekta-container py-24 text-center" data-testid="error-boundary">
            <h1 className="ekta-h2">Something went wrong</h1>
            <p className="mt-2" style={{ color: "var(--muted-ink)" }}>
              We couldn't display this content right now. Please try again.
            </p>
            <Link to="/" className="ekta-btn ekta-btn-primary mt-6">Back to Home</Link>
          </div>
        )
      );
    }
    return this.props.children;
  }
}
